module.exports = __webpack_public_path__ + "assets/img/title-6e048a8b.png";